import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { tap } from 'rxjs/operators';

@Injectable()
export class LockService {
  mode = '';
  mode$ = new BehaviorSubject(this.mode);

  constructor(private http: HttpClient) {
    this.mode$.subscribe(mode => {
      this.mode = mode;
    });
  }

  lock(params) {
    return this.http
      .put(
        'operator/requests/lock',
        {},
        {
          params: new HttpParams({ fromObject: params })
        }
      )
      .pipe(
        tap(res => {
          this.mode$.next(params.mode);
        })
      );
  }

  unlock(id) {
    return this.http
      .put(
        'operator/requests/unlock',
        {},
        {
          params: new HttpParams({ fromObject: { id } })
        }
      )
      .pipe(
        tap(res => {
          this.mode$.next(null);
        })
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/services/lock.service.ts